<template>
  <div class="content">
    <div class="container-fluid">

      <div>
        <h4 class="card-title" style="font-weight:bold;">Gestion des tarifs</h4>
      </div>
      
      <div class="row">
          
            <div class="col-md-4">
              <div class="card card-profile">
                <div class="card-avatar">
                  <h3 style="margin-left:5%">Tarif initial</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div class="">
                      <div class="form-group">
                        <input v-model="tarifs.initial" type="text" class="form-control" disabled>
                      </div>
                    </div>
                    <a @click="updateInitial()" class="btn btn-primary btn-round">Mettre à jour</a>
                  </form>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card card-profile">
                <div class="card-avatar">
                  <h3 style="margin-left:5%">Tarif petite distance</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div class="">
                      <div class="form-group">
                        <input type="text" v-model="tarifs.minidistance" class="form-control" disabled>
                      </div>
                    </div>
                    <a @click="updateMini" class="btn btn-primary btn-round">Mettre à jour</a>
                  </form>
                  
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card card-profile">
                <div class="card-avatar">
                  <h3 style="margin-left:5%">Tarif longue distance</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div class="">
                      <div class="form-group">
                        <input type="text" v-model="tarifs.longdistance" class="form-control" disabled>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                    </div>
                    <a @click="updateLong" class="btn btn-primary btn-round">Mettre à jour</a>
                  </form>
                </div>
              </div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
  import { db } from '../../main';
  import Swal from "sweetalert2";
  export default {
  name: "Tarifs",
  data() {
    return {
      tarifs: {},
    };
  },

  created() {
    let dbRef = db.ref("tarifs");
    dbRef
      .on('value', (childSnapshot) => {
        const childData = childSnapshot.val();
        this.tarifs = childData;
      })
      .catch((error) => {
        console.log(dbRef);
      });
  },

  methods : {
   async updateInitial(){
      const { value: text } = await Swal.fire({
        title: 'Entrez le nouveau tarif initial',
        input: 'number',
        inputPlaceholder: 'Entrer le tarif',
        confirmButtonColor: '#FFAB0E',
        confirmButtonText:'Modifier'
      })

      if (text) {
        db.ref("tarifs")
        .child("initial")
        .set(text)
        .then(() => {
            Swal.fire({
            position: 'center',
            icon: 'success',
            title: `Le tarif initial est ${text} FCFA`,
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
            })
        })
        .catch((error) => {
          console.log(error);
        });
      }
    },
    async updateMini(){
      const { value: text } = await Swal.fire({
        title: 'Entrez le nouveau tarif de distance minimum',
        input: 'number',
        inputPlaceholder: 'Entrer le tarif',
        confirmButtonColor: '#FFAB0E',
        confirmButtonText:'Modifier'
      })

      if (text) {
        db.ref("tarifs")
        .child("minidistance")
        .set(text)
        .then(() => {
            Swal.fire({
            position: 'center',
            icon: 'success',
            title: `Le tarif de distance minimum est ${text} FCFA`,
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
            })
        })
        .catch((error) => {
          console.log(error);
        });
      }
    },

    async updateLong(){
      const { value: text } = await Swal.fire({
        title: 'Entrez le nouveau tarif de longue distance',
        input: 'number',
        inputPlaceholder: 'Entrer le tarif',
        confirmButtonColor: '#FFAB0E',
        confirmButtonText:'Modifier'
      })

      if (text) {
        db.ref("tarifs")
        .child("longdistance")
        .set(text)
        .then(() => {
            Swal.fire({
            position: 'center',
            icon: 'success',
            title: `Le tarif d'une longue distance est ${text} FCFA`,
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
            })
        })
        .catch((error) => {
          console.log(error);
        });
      }
    }
}
}
  

</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
</style>

